import React, { useContext, useState } from "react";

import EditActivity from "./forms/edit-activity";
import EditHotel from "./forms/edit-hotel";
import EditSuperPackage from "./forms/edit-superpackage"

import {CdnPath, StaticImage} from "../../../shared/cdn-image";

//get the context
import QuoteContext from "../../quote-context";

const Day = ({ siteId, currentDay, hasSuperPackages, userHasSelectedHotel, userHasSelectedSuperPackage, removeDay }) => {
	
	const {navigation, navigationDispatcher, formDispatcher} = useContext(QuoteContext);
	const [form, setForm] = useState(false);

	const getPreferredTimeSlot = (id) => {
		if(id == 2){
			return "Evening";
		} else if(id == 1){
			return "Afternoon";
		} else {
			return "Morning"
		}
	}
	
	//BEGIN C+P FROM /myaccount
	const UnconfirmedHotelImage = (standardId, siteId) => {
		if(typeof standardId!==null){
			switch(parseInt(standardId)){
				case 1://Budget
					return <StaticImage siteId={siteId} imagePath="global/img/accommodation/budget-hotel.jpg" alt="Example of a budget hotel" cssClass="image full-width radius" />
				case 3: //Superior
					return <StaticImage siteId={siteId} imagePath="global/img/accommodation/4-hotel.jpg" alt="Example of a superior hotel" cssClass="image full-width radius" />
				case 4://Self catering
					return <StaticImage siteId={siteId} imagePath="global/img/accommodation/central-standard.jpg" alt="Example of a self catering hotel" cssClass="image full-width radius" />
				case 5: //House
					return <StaticImage siteId={siteId} imagePath="global/img/accommodation/house.jpg" alt="Example of a house" cssClass="image full-width radius" />
				default://Standard
					return <StaticImage siteId={siteId} imagePath="global/img/accommodation/standard-hotel.jpg" alt="Example of a standard hotel" cssClass="image full-width radius" />
			}
		} else {
			return <StaticImage siteId={siteId} imagePath="global/img/accommodation/standard-hotel.jpg" alt="Example of a standard hotel" cssClass="image full-width radius" />
		}
	}
	//END C+P from /myaccount

	const edit = ( day, type, item, event ) => {
		event.preventDefault();
		const height = document.getElementById( "itineraryDay" + day ).clientHeight;
		setForm({ day: day, type: type, item: item, height: height })

		navigationDispatcher({
			type: 'TRACK_EVENT',
			action: 'event',
			category: 'click',
			name:  type == 'hotel' ? 'edit-hotel' : 'edit-activity',
			trigger: 'web-js',
			data:  {
				id: item.id,
				name: item.name
			}
		})

	}

	const renderForm = () => {
		switch( form.type ) {
			case 'hotel':
				return <EditHotel hotel={form.item} hide={() => setForm(false)} height={form.height} />
			case 'superpackage':
				return <EditSuperPackage superPackage={form.item} hide={() => setForm(false)} height={form.height} />
			default:
				return <EditActivity event={form.item} hide={() => setForm(false)} height={form.height}/>
		}
	}

	const canRemove = currentDay.id > 1 && currentDay.last ? true : false;


	return (

		<div className="grid-item half mg-b-lrg">
			
			<div className="content-block border dark-stag-light-hen radius">
				<div className={canRemove ? "bg-dark-stag-light-hen pd-sm radius-t" : "bg-dark-stag-light-hen pd radius-t"}>
					<div className="align-content vertical center split">
						
						<div className="align-content vertical center">
							<span className="icon icon-cal white left"></span> 
							<p className="text-medium white no-mg-b">
								{currentDay.dayName.length > 0 ? currentDay.dayName : `Day ${currentDay.id}`}
							</p>
						</div>
					
						<div className="full-width-block">
							<div className="align-content vertical center horizontal right">
								<p className="text-medium white no-mg-b">
									{currentDay.displayDate.length > 0 ? currentDay.displayDate : null }
								</p>
								{canRemove ? (
									<button onClick={removeDay} className="button white medium radius mg-l">
										<span className="icon icon-close black small left"></span> <p className="black">Remove</p>
									</button>
								) : null}
							</div>
						</div>
					</div>
				</div>

				<div id={"itineraryDay" + currentDay.id}>
				
					{ form && form.day == currentDay.id ? (
						renderForm()
					) : (
					<>

						{ currentDay.events.length > 0 ? (
							<div className="full-width-block white pd-t">
								<div className="row no-padding">
									<div className="column">
										<div className="pd-h">
											<div className="align-content vertical center">
												<span className="icon icon-starempty black large left"></span>
												<h4 className="no-pad-b no-mg-b">Activities</h4>
											</div>
										</div>
									</div>
								</div>
							</div>
						) : null }

						{ currentDay.events.map( ( event, index ) => (
							<div key={ `select-event-${currentDay.id}-${index}` }>
								<div className="full-width-block white">
									<div className="row no-padding">
										<div className="align-content grid wrap">
											<div className="grid-item one-third-mob">
												<div className="pd-v pd-l">
													<img className="image full-width radius" src={ CdnPath( navigation.siteId, event.image.name, event.image.path, 150 ) } alt={ event.name + " image" }/>	
												</div>
											</div>			
											<div className="grid-item two-thirds-mob">
												<div className="pd-v pd-r">
													<div className="align-content vertical top mg-b-sm"><span className="icon icon-starempty mg-r"></span> <p>{event.name}</p></div>
													<div className="align-content vertical center mg-b-sm"><span className="icon icon-group mg-r"></span> <p className="mg-r-sm">{event.pax} Guests</p></div>
													<div className="align-content vertical center mg-b-sm"><span className="icon icon-clock mg-r"></span> <p>{getPreferredTimeSlot(event.preferredTimeSlot)}</p></div>
													<div className="align-content vertical center">
														
															<a onClick={(e) => edit( currentDay.id, 'event', event, e )} className="button form fit-content center radius inverted small mg-r-sm">
																<span className="icon icon-edit left small black"></span><p>edit</p>
															</a>
														
															<a className="button form radius fit-content center inverted small" onClick={() => {
																formDispatcher({type: "REMOVE_ACTIVITY", event: {id: event.id, day: currentDay.id}})
																navigationDispatcher({
																	type: 'TRACK_EVENT',
																	action: 'event',
																	category: 'click',
																	name: 'remove-activity',
																	trigger: 'web-js',
																	data: event.name
																})
															}}><span className="icon icon-close left small black"></span> <p>delete</p></a>
					
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						))}

						<div className="button dark-stag-light-hen border-t radius-b inverted pd" onClick={() => {
							console.log(currentDay.displayDate);
							navigationDispatcher({type: "GOTO_STEP", step: "activities", params: { day: currentDay.id, date: currentDay.displayDate } })
							navigationDispatcher({
								type: 'TRACK_EVENT',
								action: 'event',
								category: 'click',
								name: 'list-activity',
								trigger: 'web-js',
								data:  {
									day: currentDay.id
								}
							});
						}}>
							<div className="icon-holder">
								<span className="icon icon-addactivity black left large"></span>
							</div>
							<h4 className="black no-mg-b">Add Activities</h4>
						</div>


						{!hasSuperPackages && !currentDay.hotel && !userHasSelectedHotel ? (

							<div className="button dark-stag-light-hen border-t inverted pd radius-b-lrg" onClick={() => {
								navigationDispatcher({type: "GOTO_STEP", step: "accommodation", params: { day: currentDay.id, isPackage: false } })
								navigationDispatcher({
									type: 'TRACK_EVENT',
									action: 'event',
									category: 'click',
									name: 'list-accomodation',
									trigger: 'web-js',
									data:  {
										day: currentDay.id
									}
								});
							}}>
								<div className="icon-holder">
									<span className="icon icon-addsinglebed left black large"></span>
								</div>
								<h4 className="black no-mg-b">Add Accommodation</h4>
							</div>
							) : (
								<>
								{currentDay.hotel ? (
									<div className="full-width-block border-t dark-stag-light-hen white pd-t">
										<div className="row no-padding">
											<div className="column">
												<div className="pd-h">
													<div className="align-content vertical center">
														<span className="icon icon-singlebed black large left"></span>
														<h4 className="no-pad-b no-mg-b">Accommodation</h4>
													</div>
												</div>
											</div>
										</div>
									</div>
								) : null }
								</>
							)}

						{!hasSuperPackages && currentDay.hotel ? (
							<>
								<div className="full-width-block white radius-b-lrg">
									<div className="row no-padding">
										<div className="align-content grid wrap">
											<div className="grid-item one-third-mob">
												<div className="pd-v pd-l">

													{currentDay.hotel.image!==null ? (
														<img className="image radius full-width" src={CdnPath(navigation.siteId, currentDay.hotel.image.name, currentDay.hotel.image.path, 150, false, false, false )} alt={currentDay.hotel.name + " image"}/>
													) : null}

													{currentDay.hotel.image===null && currentDay.hotel.type == "unnamed" ? (
														<div>
															{UnconfirmedHotelImage(currentDay.hotel.id, navigation.siteId)}
														</div>
													) : null}

												</div>
											</div>			
											<div className="grid-item two-thirds-mob">
												<div className="pd-v pd-r">
													<div className="align-content vertical center mg-b-sm"><span className="icon icon-hotel mg-r"></span> <p>{currentDay.hotel.name}</p></div>
													<div className="align-content vertical center mg-b-sm"><span className="icon icon-group mg-r"></span> <p>{currentDay.hotel.pax} Guests</p></div>
													<div className="align-content vertical center mg-b-sm"><span className="icon icon-night mg-r"></span> <p>{currentDay.hotel.nights} {currentDay.hotel.nights==1 ? "Night" : "Nights"}</p></div>
													<div className="align-content vertical center">
													
															<a className="button form fit-content center radius inverted small mg-r-sm" onClick={(e) => edit( currentDay.id, 'hotel', currentDay.hotel, e )}>
																<span className="icon icon-edit left small black"></span><p>edit</p>
															</a>
													
														
															<a className="button form radius fit-content center inverted small" onClick={() => {
																formDispatcher({type:"REMOVE_HOTEL"})
																navigationDispatcher({
																	type: 'TRACK_EVENT',
																	action: 'event',
																	category: 'click',
																	name: 'remove-accomodation',
																	trigger: 'web-js',
																	data: currentDay.hotel.name
																})
															}}><span className="icon icon-close left small black"></span> <p>delete</p></a>
														
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								{ siteId != 1 ?
									<div className="full-width-block">
										<div className="row no-padding">
											<div className="content-block green radius pd-sm mg-b mg-h border fill">
												<div className="align-content vertical center">
													<span className="icon icon-shield medium green left"></span>
													<p className="no-mg-b green spirit">Price match promise</p>
												</div>
											</div>
										</div>
									</div>
								: null }
							</>
						) : null }

						{hasSuperPackages && !currentDay.superPackage && !userHasSelectedSuperPackage ? (

						<div className="button dark-stag-light-hen thick border-t inverted radius-b pd" onClick={() => {
							navigationDispatcher({type: "GOTO_STEP", step: "superPackages", params: { day: currentDay.id } })
							navigationDispatcher({
								type: 'TRACK_EVENT',
								action: 'event',
								category: 'click',
								name: 'list-superPackages',
								trigger: 'web-js',
								data:  {
									day: currentDay.id
								}
							});
						}}>
							<div className="icon-holder">
								<span className="icon icon-addsinglebed black left large"></span>
							</div>
							<h4 className="black no-mg-b">Add Accommodation</h4>
						</div>
						) : (
						<>
						{currentDay.superPackage ? (
							<div className="full-width-block white border-t thick secondary-dark pd-t">
								<div className="row">
									<div className="column">
										<h3>Accommodation</h3>
									</div>
								</div>
							</div>
						) : null }
						</>
						)}


						{hasSuperPackages && currentDay.superPackage ? (
							<>
								<div className="full-width-block white">
									<div className="row no-padding">
										<div className="align-content grid wrap">
											<div className="grid-item one-third-mob">
												<div className="pd-v pd-l">
													{ currentDay.superPackage.image!==null ? (
														<img className="image radius full-width" src={ CdnPath( navigation.siteId, currentDay.superPackage.image.name, currentDay.superPackage.image.path, 150 )} alt={ currentDay.superPackage.name + " image" }/>
													) : null }
												</div>
											</div>			
											<div className="grid-item two-thirds-mob">
												<div className="pd-v pd-r">
													<div className="align-content vertical center mg-b-sm"><span className="icon icon-hotel mg-r"></span> <p>{ currentDay.superPackage.name }</p></div>
													<div className="align-content vertical center mg-b-sm"><span className="icon icon-group mg-r"></span> <p>{ currentDay.superPackage.pax } Guests</p></div>
													<div className="align-content vertical center mg-b-sm"><span className="icon icon-night mg-r"></span> <p>{ currentDay.superPackage.nights } { currentDay.superPackage.nights==1 ? "Night" : "Nights" }</p></div>
													<div className="align-content vertical center">
														
															<a className="button form fit-content center radius inverted small mg-r-sm" onClick={(e) => edit( currentDay.id, 'superpackage', currentDay.superPackage, e )}>
																<span className="icon icon-edit left small black"></span><p>edit</p>
															</a>
														
															<a className="button form radius fit-content center inverted small" onClick={() => {
																formDispatcher({type:"REMOVE_SUPER_PACKAGE"})
																navigationDispatcher({
																	type: 'TRACK_EVENT',
																	action: 'event',
																	category: 'click',
																	name: 'remove-superpackage',
																	trigger: 'web-js',
																	data: currentDay.superPackage.name
																})
															}}><span className="icon icon-close left small black"></span> <p>delete</p></a>
													
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</>
						) : null }
					</>
					)}
				</div>
			</div>
			
		</div>
	)
}

export default Day
